import { useOutlet } from "react-router-dom";

const OfferLayout = () => {
  const outlet = useOutlet();
  return outlet;
};

export default OfferLayout;
